module.exports = __webpack_public_path__ + "static/media/ipat.1c161c7b.png";